const filterTag =  [
    {
        "type": "all",
        "name": "ALL",
        "order": 0,
        "icon": ""
    },
    {
        "type": "solve",
        "name": "解題救援",
        "order": 1,
        "icon": "https://public.ehanlin.com.tw/web/eh-message/icon-solve.svg"
    },
    {
        "type": "activity",
        "name": "學習活動",
        "order": 2,
        "icon": "https://public.ehanlin.com.tw/web/eh-message/icon-activity.svg"
    },
    {
        "type": "hot",
        "name": "熱門訊息",
        "order": 3,
        "icon": "https://public.ehanlin.com.tw/web/eh-message/icon-news.svg"
    }
];

const TAB_ACTIVE_CLASS = "tab-active";

const transferTime = (time) => {
    function getzf(num) {
        if(parseInt(num) < 10){  
            num = '0' + num;  
        }  
        return num;  
    }

    let date = new Date(time);
    let month = getzf(date.getMonth()+1);
    let day = getzf(date.getDate())
    let hour = getzf(date.getHours())
    let min = getzf(date.getMinutes())
    let s = getzf(date.getSeconds())
    
    let fullDate = (date.getFullYear()+ "."+ month + "."+ day +"  "+ hour + ":"+ min + ":"+ s);
    return fullDate;
}   

const replaceAllSpaceAndNewLineChar = (str) => {
    str = str.replaceAll('\\n','');
    str = str.replaceAll('\\','');
    return str;
}   

var messageShadowRoot = null;
var ehMessage = [];

// 顯示與隱藏列表
const showHideList = () => {
    messageShadowRoot.querySelectorAll('#itemListMessage').forEach((m) => {
        m.removeEventListener('click', ()=>{});
        m.addEventListener('click', () => {
            messageShadowRoot.querySelector('.message-content').classList.add('slideInUp');
            messageShadowRoot.querySelector('.message-content').classList.remove('dn');
            messageShadowRoot.querySelector('.message-list').classList.add('dn');
            messageShadowRoot.querySelector('.message-list').classList.remove('fadeInUp');
            updateContents(m);
        });
    });
}

// 更新打開的訊息內容
const updateContents = (selected) => {
    let selectedMessage = ehMessage.find((i)=>{
        return i._id === selected.dataset.item
    })

    let contentDom = messageShadowRoot.querySelector('#messageContent');

    let series = filterTag.find((obj)=>{
        return obj.type === selectedMessage.filterTag
    })
    // let icon = series ? series.icon : "https://public.ehanlin.com.tw/web/eh-message/icon-history.svg"
    // let name = series ? series.name : "歷史訊息"

    contentDom.innerHTML = `
    <div class="item-message" id="itemContentMessage" data-item="`+selectedMessage._id+`">
        <div class="item-top">
            <div class="item-icon"><img src="`+series.icon+`" alt=""></div>
            <div class="item-title">`+series.name+`</div>
            <div class="item-date">`+transferTime(typeof selectedMessage.modifyDate.toDate === 'function' ? selectedMessage.modifyDate.toDate():selectedMessage.modifyDate)+`</div>
        </div>
        <div class="item-bottom">
            <div class="title-message">`+selectedMessage.title+`</div>
            <div class="content-message">`+replaceAllSpaceAndNewLineChar(selectedMessage.content)+`</div>
        </div>
    </div>`;

    

    if(selected.querySelector('.message-unread')!=null){
        Promise.all([
            window.eHanlin.dataprovider.ehMessage.updateReadStatus(selected.dataset.item)])
        .then(([data])=>{
            if(data.read){
                selected.querySelector('.message-unread').classList.remove('message-unread');
            }
        })
    }
}

{
    const template = `
        <style type="text/css">
            html {
                margin: 0 0;
                padding: 0 0;
            }
            body {
                margin: 0 0;
                padding: 0 0;
                background: #dddddd;
            }
            * {
                outline: 0;
                box-sizing: border-box;
            }
            .dn {
                display: none
            }
            .fadeIn{
                -webkit-animation-name: bg-fade;
                animation: fadeIn .3s ease-out;
            }
            @keyframes fadeIn {
                from{
                    opacity: 0;
                }
                to{
                    opacity: 1;
                }
            }
            .fadeInUp{
                animation: fadeInUp 0.5s forwards ease 0.2s;
                display: block !important;
                opacity: 0;
            }
            @keyframes fadeInUp {
                from{
                    opacity: 0;
                    -webkit-transform: translateY(10px);
                    transform: translateY(10px);
                }
                to{
                    opacity: 1;
                    -webkit-transform: translateY(0px);
                    transform: translateY(0px);
                }
            }
            .slideInRight{
                animation: slideInRight 0.7s forwards ease;
                display: block !important;
            }
            @keyframes slideInRight {
                from{
                    display: block;
                    opacity: 0;
                    -webkit-transform: translateX(10%);
                    transform: translateX(10%);
                }
                to{
                    opacity: 1;
                    -webkit-transform: translateX(0px);
                    transform: translateX(0);
                }
            }
            .slideInUp{
                animation: slideInUp 0.5s forwards ease 0.2s;
                display: block !important;
            }
            @keyframes slideInUp {
                from{
                    display: block;
                    opacity: 0;
                    -webkit-transform: translateY(10px);
                    transform: translateY(10px);
                }
                to{
                    opacity: 1;
                    -webkit-transform: translateY(0px);
                    transform: translateY(0);
                }
            }

            .message{
                position: fixed;
                width: 100%;
                height: 100%;
                left: 0;
                top: 0;
                z-index: 99999;
            }
            .fade {
                opacity: 0;
                transition: opacity .15s linear;
            }
            .fade.show {
                opacity: 1;
            }
            .wrap-bg{
                width: 100%;
                height: 100%;
                background-color: rgba(0,0,0,70%);
            }
            @media (max-width: 767px){
                .wrap-bg{
                    display: none
                }
            }
            .wrap-box{
                width: 400px;
                height: 100vh;
                padding: 24px 24px 24px 0;
                position: absolute;
                right: 0;
                top: 0;
                background-color: #f5f5f5;
                box-shadow: 0 0 5px rgb(0 0 0 / 15%);
                color: #454545;
                font-family: 'Noto Sans TC',sans-serif;
            }

            @media (max-width: 767px){
                .wrap-box{
                    width: 100%;
                }
            }
            .title{
                font-weight: 500;
                font-size: 20px;
                margin-bottom: 16px;
                position: relative;
                user-select: none;
                padding-left: 24px;
            }
            @media (max-width: 767px){
                .title{
                    font-size: 18px;
                }
            }
            .btn-close{
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                position: absolute;
                top: -14px;
                right: -14px;
                cursor: pointer;
                -webkit-transition: 0.2s;
                transition: 0.2s;
            }
            .btn-close:hover{
                -webkit-transform: scale(0.9);
                transform: scale(0.9);
            }
            .row-tab{
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-pack: space-between;
                -ms-flex-pack: space-between;
                justify-content: space-between;
                margin-bottom: 12px;
                padding-left: 24px;
            }
            .tab{
                width: 80px;
                padding: 12px 0;
                background-color: #ffffff;
                color: #0D6CBE;
                text-align: center;
                border-radius: 5px;
                font-size: 14px;
                cursor: pointer;
                font-weight: 500;
            }
            @media (max-width: 767px){
                .tab{
                    width: 100%;
                    margin-right: 8px;
                }
                .tab:last-child{
                    margin-right: 0px;
                }
            }
            .tab:hover{
                box-shadow: 0 0 5px rgb(0 0 0 / 10%);
                background-color: #edf7ff;
            }
            .row-tab .tab-active{
                color: #ffffff;
                background-color: #0D6CBE;
            }
            .row-content{
                height: calc(100vh - 170px);
                overflow: auto;
                padding-top: 2px;
                padding-left: 24px
            }
            .row-history{
                text-align: center;
                padding-top: 8px;
            }
            .row-history a{
                text-decoration: none;
                color: #aaa;
                font-size: 14px;
            }
            ::-webkit-scrollbar {
                width: 14px;
            }

            ::-webkit-scrollbar-thumb {
                border: 4px solid rgba(0, 0, 0, 0);
                background-clip: padding-box;
                border-radius: 100px;
                background-color: #ddd;
            }

            .item-message{
                background: #FFFFFF;
                border-radius: 5px;
                padding: 8px 12px;
                cursor: pointer;
                margin-bottom: 12px;
                -webkit-transition: 0.2s;
                transition: 0.2s;
                position: relative;
            }

            .message-unread{
                left: -6px;
                top: 14px;
                border: solid 2px #f5f5f5;
                position: absolute;
                width: 12px;
                height: 12px;
                border-radius: 20px;
                background: #FF6767;
                display: block;
            }

            #messageContainer .item-message:hover{
                -webkit-transform: translateY(-2px);
                transform: translateY(-2px);
                box-shadow: 0 2px 5px rgb(0 0 0 / 8%);
            }

            .item-message .item-top{
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                -webkit-box-pack: space-between;
                -ms-flex-pack: space-between;
                justify-content: space-between;
                margin-bottom: 4px;
            }
            .item-message .item-top .item-icon{
                margin-right: 4px;
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                -webkit-box-pack: center;
                -ms-flex-pack: center;
                justify-content: center;
            }
            .item-message .item-top .item-title{
                font-weight: 500;
                width: 100%;
            }
            .item-message .item-top .item-date{
                font-size: 12px;
                color: #A5A5A5;
                white-space: nowrap;
            }
            .item-message .item-bottom .title-message{
                font-size: 14px;
                margin-bottom: 4px;
                max-width: 100%;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis
            }
            .item-message .item-bottom .content-message{
                font-size: 12px;
                color: #9E9E9E;
                max-width: 100%;
                height: 20px;
                overflow: hidden;
            }
            .item-message .item-bottom .content-message p{
                margin-top: 0;
                overflow: hidden;
                max-width: 100%;
                white-space: nowrap;
                text-overflow: ellipsis
            }

            .message-content{
                opacity: 0
            }

            #messageContent{
                height: calc(100vh - 180px);
                margin-bottom: 16px;
            }
            #messageContent .item-message{
                cursor: default;
                margin-bottom: 0;
            }
            #messageContent .item-message .item-top{
                margin-bottom: 8px;
            }
            #messageContent .item-message .item-bottom .content-message{
                height: auto;
            }
            #messageContent .item-message .item-bottom .content-message p{
                overflow: visible;
                white-space: initial;
                font-size: 14px;
            }
            #messageContent .item-message .item-bottom .content-message p a{
                color: #0D6CBE;
                padding: 8px 12px;
                border-radius: 5px;
                border: 1px solid #0D6CBE;
                display: inline-block;
                text-decoration: none;
            }
            #messageContent .item-message .item-bottom .content-message p a:hover{
                color: #065DA7;
                border: 1px solid #065DA7;
            }
            #messageContent .item-message .item-bottom .content-message p:first-child a{
                padding: 0px;
                border-radius: 0px;
                border: none;
                text-decoration: underline;
            }
            #messageContent .item-message .item-bottom .content-message img{
                width: 100%;
            }
            .row-button{
                text-align: center;
            }
            .btn-back{
                display: inline-block;
                padding: 12px 24px;
                border-radius: 5px;
                cursor: pointer;
                font-weight: 500;
                color: #ffffff;
                background-color: #0D6CBE;
            }
            .btn-back:hover{
                background-color: #065DA7;
            }
            .opacity-1 {
                opacity: 1;
            }
        </style>

        <div class="message">
            <div class="wrap-bg fadeIn"></div>
            <div class="wrap-box slideInRight">
                <div class="title">學院訊息中心
                    <div class="btn-close">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L13 13" stroke="#454545" stroke-width="2"></path>
                            <path d="M13 1L1 13" stroke="#454545" stroke-width="2"></path>
                        </svg>
                    </div>
                </div>
                <div class="message-list">
                    <div class="row-tab" id="selectFilter"></div>
                    <div class="row-content" id="messageContainer"></div>
                    <div class="row-content" id="noMessage" style="padding-top: 60px;text-align: center;">
                        <img src="https://public.ehanlin.com.tw/web/eh-message/icon-notfound.svg" style="width: 36px;">
                        <p style="color: #a5a5a5">找不到相符的訊息</p>
                    </div>
                    <div class="row-history" id="historyMessage">
                        <a href="/app/message-center/message-list.html" target="_blank">歷史訊息</a>
                    </div>
                </div>
                <div class="message-content dn">
                    <div class="row-content" id="messageContent"></div>
                    <div class="row-button">
                        <div class="btn-back">返回列表</div>
                    </div>
                </div>
            </div>
        </div>
    `;
    
    customElements.define('eh-message', class extends HTMLElement {
        constructor() {
            super();
            messageShadowRoot = this.attachShadow({mode: 'open'});
            messageShadowRoot.innerHTML = template;
            this.closeBtn = this.shadowRoot.querySelector('.btn-close');
            this.wrapBg = this.shadowRoot.querySelector('.wrap-bg');
            this.wrapBox = this.shadowRoot.querySelector(".wrap-box");
            this.wrapMessage = this.shadowRoot.querySelector(".message");
        
            const ALL = "all";
            const paresHtml = (html, parent) => {
                if(!parent){
                    parent = document.body;
                }
                let range = document.createRange();
                range.selectNode(parent);
                let result = range.createContextualFragment(html).firstElementChild;
                range.detach();
                return result;
            } 

            const init = ([messageData]) => {
                window.eHanlin.dataprovider.ehMessage.setUnreadCount();
                ehMessage = messageData;

                let selectFilter = messageShadowRoot.querySelector('#selectFilter');
                let showsDom = messageShadowRoot.querySelector('#messageContainer');
                let noItemsDom = messageShadowRoot.querySelector('#noMessage');

                let typeOrders = ['ALL', '解題救援', '學習活動', '熱門訊息'];
                filterTag.forEach(type => {
                    if(typeOrders.includes(type.name)){
                        type.order = typeOrders.indexOf(type.name);
                    } 
                })
                filterTag.sort(function(a, b){
                    return a.order - b.order;
                })

                filterTag.forEach((it) => {
                    let actived = (it.type == 'all') ? TAB_ACTIVE_CLASS : '' ;
                    selectFilter.appendChild(
                        paresHtml(`<div class='tab ${actived}' data-type='${it.type}'>${it.name}</a>`, selectFilter));
                });

                const clearList = () => {
                    showsDom.innerHTML = '';
                }

                const afterRefreshData = () => {
                    if(ehMessage.length === 0){
                        noItemsDom.classList.remove('dn');
                        showsDom.classList.add('dn');
                    }
                    else{
                        noItemsDom.classList.add('dn');
                        showsDom.classList.remove('dn');
                    }
                }

                // 更新訊息清單
                const updateMessages = (message) => {       
                    message.forEach((item) => {
                        let series = filterTag.find((obj)=>{
                            let filter = item.filterTag
                            return obj.type == filter
                        })
                        if(series!=null){
                            let read = item.read ? '' : 'message-unread'
                            
                            showsDom.innerHTML += `
                            <div class="item-message" id="itemListMessage" data-item="`+item._id+`">
                                <div class="item-top">
                                    <div class="item-icon"><img src="`+series.icon+`" alt=""></div>
                                    <div class="item-title">`+series.name+`</div>
                                    <div class="item-date">`+transferTime(typeof item.modifyDate.toDate === 'function' ? item.modifyDate.toDate():item.modifyDate)+`</div>
                                </div>
                                <div class="item-bottom">
                                    <div class="title-message">`+item.title+`</div>
                                    <div class="content-message">`+replaceAllSpaceAndNewLineChar(item.content)+`</div>
                                </div>
                                <div class="${read}"></div>
                            </div>`;
                        }
                    });   
                }

                if(ehMessage.length === 0){
                    noItemsDom.classList.remove('dn');
                    showsDom.classList.add('dn');
                }
                else{
                    noItemsDom.classList.add('dn');
                    showsDom.classList.remove('dn');
                }
                updateMessages(ehMessage);

                messageShadowRoot.querySelectorAll('#selectFilter .tab').forEach((a) => {
                    a.addEventListener('click', () => {
                        messageShadowRoot.querySelectorAll('#selectFilter .tab').forEach((item) => item.classList.remove(TAB_ACTIVE_CLASS));
                        a.classList.add(TAB_ACTIVE_CLASS);
                        let filterActive = selectFilter.querySelector(`.${TAB_ACTIVE_CLASS}`).dataset.type;
                        clearList();
                        if(filterActive === "all"){
                            Promise.all([
                                window.eHanlin.dataprovider.ehMessage.dataFirstPage(userId)])
                            .then(([data])=>{
                                ehMessage = data;
                                updateMessages(ehMessage);
                                afterRefreshData();
                                showHideList();
                            })
                        }else{
                            Promise.all([
                                window.eHanlin.dataprovider.ehMessage.dataByFilter(userId, filterActive)])
                            .then(([data])=>{
                                ehMessage = data;
                                updateMessages(ehMessage);
                                afterRefreshData();
                                showHideList();
                            })
                        }
                    }, false);
                });

                messageShadowRoot.querySelector('.btn-back').addEventListener('click', () => {
                    messageShadowRoot.querySelector('.message-content').classList.add('dn');
                    messageShadowRoot.querySelector('.message-content').classList.remove('slideInUp');
                    messageShadowRoot.querySelector('.message-list').classList.add('fadeInUp');
                    messageShadowRoot.querySelector('.message-list').classList.remove('dn');
                    clearMessage();
                });

                // 清空訊息
                const clearMessage = () => {
                    let contentDom = messageShadowRoot.querySelector('#messageContent');
                    contentDom.innerHTML = ''
                }

                showHideList();

                let scrollDiv = messageShadowRoot.querySelector('#messageContainer');
                scrollDiv.onscroll = function(ev) {
                    if ((scrollDiv.scrollTop + scrollDiv.offsetHeight) >= scrollDiv.scrollHeight) {
                        let filterActive = selectFilter.querySelector(`.${TAB_ACTIVE_CLASS}`).dataset.type;
                        if(filterActive === "all"){
                            Promise.all([
                                window.eHanlin.dataprovider.ehMessage.getMoreData(userId, null)])
                            .then(([data])=>{
                                ehMessage = ehMessage.concat(data);
                                updateMessages(data);
                                showHideList();
                            })
                        }else{
                            Promise.all([
                                window.eHanlin.dataprovider.ehMessage.getMoreData(userId, filterActive)])
                            .then(([data])=>{
                                ehMessage = ehMessage.concat(data);
                                updateMessages(data);
                                showHideList();
                            })
                        }
                    }
                };
            }

            let userId = "";
            if(typeof getEhToken == 'function') { 
                if(getEhToken().user!=undefined){
                    userId = getEhToken().user.userId;
                    Promise.all([
                        window.eHanlin.dataprovider.ehMessage.dataFirstIn(userId)])
                    .then(init)
                }
            } 
        }

        get open() {
            return this.getAttribute('open');
        }
        set open(newValue) {
            this.setAttribute('open', newValue);
        }
        static get observedAttributes() {
            return ['open'];
        }
        _closeMessage() {
            this.setAttribute('open', 'false');
        }
        attributeChangedCallback(name, oldValue, newValue) {
            if(name === 'open'){
                const ehMessage = this;
                if(newValue === 'true') {
                    document.querySelector("eh-navbar").shadowRoot.querySelector("eh-message").style.display="block";
                    ehMessage.wrapBox.classList.add('slideInRight');
                    ehMessage.wrapMessage.classList.add('fade','show');
                    document.body.style.overflow="hidden";
                    document.body.style.paddingRight="17px"
                    document.body.style.transition="unset"
                }
                else if(newValue === 'false' && oldValue !== null) {
                    ehMessage.wrapBox.classList.remove('slideInRight');
                    ehMessage.wrapMessage.classList.remove('show');
                    setTimeout(function(){
                        document.querySelector("eh-navbar").shadowRoot.querySelector("eh-message").style.display="none";
                        ehMessage.innerHTML = '';
                    },200)
                }
            }
        }
        connectedCallback() {
            const ehMessage = this;
            if(!this.hasAttribute('open')){
                ehMessage._closeMessage();
                document.querySelector("eh-navbar").shadowRoot.querySelector("eh-message").style.display="none";
                document.body.style.overflow="initial";
                document.body.style.paddingRight="0px"
            }
            this.closeBtn.addEventListener('click', function(){
                ehMessage._closeMessage();
                document.body.style.overflow="initial";
                document.body.style.paddingRight="0px"
            });
            this.wrapBg.addEventListener('click', function(){
                ehMessage._closeMessage();
                document.body.style.overflow="initial";
                document.body.style.paddingRight="0px"
            });
            window.onscroll = () => {
                document.body.style.transition="all 0.3s"
            }
        }
    });
};

const isLocal = window.location.protocol.toLowerCase() == 'file:';
const updateUnreadCount = (count) => {
    if(!isLocal){
        let shadow = document.querySelector('eh-navbar').shadowRoot;
        if(shadow!=null){
            shadow.querySelectorAll('#mail_sum').forEach((item)=>{
                item.innerHTML = count;
            })
        }
    }
}

const updateOnUpdateMessage = (data) => {
    let selectFilter = messageShadowRoot.querySelector('#selectFilter');
    let filterActive = selectFilter.querySelector(`.${TAB_ACTIVE_CLASS}`).dataset.type;
    let showsDom = messageShadowRoot.querySelector('#messageContainer');
    data.slice().reverse().forEach((datum)=>{
        ehMessage.push(datum);
        if(filterActive=="all" || filterActive==datum.filterTag){
            let series = filterTag.find((obj)=>{
                let filter = datum.filterTag
                return obj.type == filter
            })
            if(series!=null){
                let read = datum.read ? '' : 'message-unread';
                
                showsDom.insertAdjacentHTML('afterbegin',`
                <div class="item-message" id="itemListMessage" data-item="`+datum._id+`">
                    <div class="item-top">
                        <div class="item-icon"><img src="`+series.icon+`" alt=""></div>
                        <div class="item-title">`+series.name+`</div>
                        <div class="item-date">`+transferTime(typeof datum.modifyDate.toDate === 'function' ? datum.modifyDate.toDate():datum.modifyDate)+`</div>
                    </div>
                    <div class="item-bottom">
                        <div class="title-message">`+datum.title+`</div>
                        <div class="content-message">`+replaceAllSpaceAndNewLineChar(datum.content)+`</div>
                    </div>
                    <div class="${read}"></div>
                </div>`);
            }
        }
    });
    showHideList();
}

openMessage = () => {
    document.querySelector("eh-navbar").shadowRoot.querySelector('eh-message').setAttribute('open', 'true');
};
closeMessage = () => {
    document.querySelector("eh-navbar").shadowRoot.querySelector('eh-message').setAttribute('open', 'false');
};